module.exports = __webpack_public_path__ + "img/texuship.22556b65.png";